import React, { useState, useCallback, useEffect } from "react";
import "./App.less";
import { Menu as AntMenu, Spin, ConfigProvider, Layout, Alert } from "antd";
import { BricksCanvas } from "./fragments/BricksCanvas";
import Menu from "./fragments/Menu";
import { useAppSelector, useAppDispatch } from "./store/hooks";
import { selectBricksLoading, selectBricksError, fetchBricks } from "./store/slices/bricksSlice";
import { selectDrawing, selectRenderError } from "./store/slices/wallManagerSlice";
import { selectMissingImages } from "./store/slices/configurationSlice";
import Logo from './assets/Ploegsteert-RGB-lang.png'

const App: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(true);
  const dispatch = useAppDispatch();
  const bricksLoading = useAppSelector(selectBricksLoading);
  const bricksError = useAppSelector(selectBricksError);
  const renderError = useAppSelector(selectRenderError);
  const error = bricksError ?? renderError;
  const missingImages = useAppSelector(selectMissingImages);
  const wallManagerDrawing = useAppSelector(selectDrawing);

  useEffect(() => {
    dispatch(fetchBricks());
  }, [dispatch]);

  const handleMenuClick = useCallback(() => {
    setMenuOpen((oldValue) => !oldValue)
  }, [setMenuOpen]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerBg: '#ffffff',
            headerHeight: 48,
            headerPadding: 12,
          }
        },
        token: {
          colorPrimary: '#d23a2a',
        },
      }}
    >
      <Layout className="App">
      <Layout.Header style={{ display: 'flex', alignItems: 'center' }}>
          <img src={Logo} height={32}/>
        <AntMenu
          mode="horizontal"
          selectedKeys={[menuOpen ? 'menu' : '']}
          items={[
            {
              key: 'menu',
              label: <div style={{ fontWeight: 'bold'}}>Menu</div>,
              onClick: handleMenuClick
            }
          ]}
          style={{ flex: 1, minWidth: 0 }}
        >
          
        </AntMenu>
        </Layout.Header>
        {(wallManagerDrawing || bricksLoading) && (
          <div className="spinner">
            <Spin />
          </div>
        )}
        {error && (
          <Alert
            type="error"
            showIcon
            title={bricksError ? "De stenen konden niet geladen worden." : "De muur kon niet getekend worden."}
            description={error}
          />
        )}
        {!error && missingImages.length > 0 && (
          <Alert
            type="warning"
            showIcon
            title="Niet alle stenen konden geladen worden."
            description={`${missingImages.length} afbeelding(en) worden overgeslagen: ${missingImages.join(", ")}`}
          />
        )}
        {menuOpen && <Menu />}
        <BricksCanvas />
      </Layout>
    </ConfigProvider>
  );
};

export default App;
